export default {"src":"/_next/static/media/premium_bg.0fe6164a.svg","height":101,"width":150};